import { ROUTER_PATHS } from '@/lib/constants'
import { InspectionCornSchema } from '@eigtech/inspections-types'
import { JobIdSchema } from '@eigtech/restoration-types'
import { ensureJobCorn } from '@eigtech/restoration-util'
import { InspectionDetail } from '@eigtech/ui-shared-inspections-web'
import { Container } from '@eigtech/ui/components/container'
import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { z } from 'zod'

const Schema = z.object({
  jobId: JobIdSchema,
  inspectionId: InspectionCornSchema,
})

export const Route = createFileRoute('/_auth/jobs/$jobId/_layout/inspections_/$inspectionId')({
  component: RouteComponent,
  parseParams: Schema.parse,
})

function RouteComponent() {
  const { jobId, inspectionId } = Route.useParams()

  return (
    <Container className="my-4 space-y-4">
      <Link
        className="text-primary inline-flex w-fit items-center gap-1.5 text-sm hover:underline"
        params={{ jobId }}
        to={ROUTER_PATHS.jobDetailInspections.route}
      >
        <ArrowLeft className="size-4" />
        Back to Inspections
      </Link>

      <InspectionDetail entityId={ensureJobCorn(jobId)} inspectionId={inspectionId} />
    </Container>
  )
}
